import { useState, useMemo } from 'react';
import { SelectBox } from '@/components/SelectBox';

const SelectLocalidadProvincia = ({ localidades, provincias, check, onChange }) => {
  const [selectedProvincia, setSelectedProvincia] = useState('');
  const [selectedLocalidad, setSelectedLocalidad] = useState('');

  const provinciasCurr = useMemo(() => {
    if (!provincias || !provincias.length) return [];
    return provincias.map((x) => ({
      value: x.name,
      text: x.name
    }));
  }, [provincias]);

  const localidadesCurr = useMemo(() => {
    return localidades
      .filter((localidad) => localidad.provincia.name === selectedProvincia)
      .map((x) => ({
        value: x.name,
        text: x.name
      }));
  }, [selectedProvincia, localidades]);

  const handleProvinciaChange = (e) => {
    setSelectedProvincia(e.value);
    onChange({
      target: {
        name: 'provincia',
        text: e.label
      }
    });
  };

  const handleLocalidadChange = (x) => {
    setSelectedLocalidad(x.value);
    onChange({
      target: {
        name: 'localidad',
        text: x.label
      }
    });
  };

  return (
    <div className="flex flex-col sm:flex-row items-center sm:mb-24">
      <div className="w-full sm:mr-9 mb-20 sm:mb-0">
        <SelectBox
          title="Provincia"
          validation={check}
          name="provincia"
          value={selectedProvincia}
          onChange={handleProvinciaChange}
          options={provinciasCurr}
        />
      </div>
      <div className="w-full sm:ml-9 mb-20 sm:mb-0">
        <SelectBox
          title="Localidad"
          validation={check}
          name="localidad"
          value={selectedLocalidad}
          onChange={handleLocalidadChange}
          options={localidadesCurr}
          placeholder="Seleccione una localidad"
        />
      </div>
    </div>
  );
};

export default SelectLocalidadProvincia;
